import { CrudService } from './crud.service';
import { ClientCreateUpdateDto as DTO } from '@shared/dto/client';
import { ClientResource as Res } from '@shared/resources/client';

export class ClientService extends CrudService<DTO, DTO, Res> {
  protected pathPrefix(): string {
    return 'clients';
  }
}
